<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="terms-of-service">
      <Title jpn="服务条款" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">关于Xero Place Co., Ltd.（以下简称“公司”）在本网站上提供的服务（以下简称“服务”）以及本公司与服务使用者之间的权利和义务关系的条款和条件，在网站使用条款（包括本公司作为合同内容另行规定的任何其他规定；以下简称“条款”）中规定如下。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第一条（术语定义）</span>
            <span class="text">本条款中下列各项中术语的含义应按各项规定。</span>
            <span class="text">(1) “公司”是指提供本服务的Zero Place Co., Ltd.。</span>
            <span class="text">(2) “本网站”是指本公司提供的网站
              <a href="https://gtchaxonline.com/" target="_blank">https://gtchaxonline.com/</a>
              。</span>
            <span class="text">(3)“条款”是指服务使用者必须遵守的规定。</span>
            <span class="text">(4) “服务使用协议”是指有关服务使用的合同。</span>
            <span class="text">(5) “服务使用者”是指与本公司签订服务使用合同的人。</span>
            <span class="text">(6) “账户”是指服务使用者在本服务中注册的与服务使用者相关的信息。</span>
            <span class="text">(7) “密码”是指由客户创建的字母数字字符组合组成的代码。</span>
            <span class="text">(8) “电子邮件地址”是指服务使用者在本服务中注册的电子邮件地址。</span>
            <span class="text">(9) “货币”是指可以在本网站内使用的虚拟货币。</span>
            <span class="text">(10)“产品”是指可以通过本网站的游戏获得的卡牌。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第二条（适用范围）</span>
            <span class="text">1 服务使用者必须按照本条款的规定使用本网站，除非同意本条款，否则不能使用本网站。</span>
            <span class="text">2 服务利用者在本网站的注册画面上完成同意本条款的手续后，服务利用者与本公司之间将建立符合本条款规定的使用合同（以下简称“使用协议”），本条款的内容将成为服务利用者与公司之间的合同内容。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第3条（服务内容等）</span>
            <span class="text">1 本服务的内容及使用流程详见使用指南。</span>
            <span class="text">2 本公司可随时自行决定变更本服务的内容或终止提供本服务。</span>
            <span class="text">3 服务使用者不得对本公司变更服务内容或终止提供服务提出异议，或提出任何损害赔偿或其他索赔要求。</span>
            <span class="text">4 如果终止提供本服务，应按照公司规定的方式提前通知用户。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第四条（使用申请）</span>
            <span class="text">1 如果您希望使用本服务，您必须访问本网站，同意本使用条款，并申请使用本服务（以下简称“服务使用申请”）。</span>
            <span class="text">2 当公司接受服务使用申请时，公司与服务使用申请者（以下简称“服务使用申请人”）之间将根据本条款签订服务使用合同。</span>
            <span class="text">3 如果希望使用本网站的人是未成年人等，则在使用本网站之前必须事先获得父母或监护人等法定代表人的同意。如果未成年人等同意本条款，则视为已获得其法定代理人的同意，我们不承担任何责任。</span>
            <span class="text">4 我公司可能不接受您的服务使用申请。在此情况下，我公司没有义务披露原因。</span>
            <span class="text">5 服务使用申请人在申请使用服务时不得提交不准确或虚假的信息。</span>
            <span class="text">6 即使因账户信息错误、变更延迟或其他缺陷而导致本服务的使用出现问题，本公司也不对此承担责任。</span>
            <span class="text">7 本条款和 Coin 使用条款是公司与服务用户之间关于使用
              <a href="https://gtchaxonline.com/" target="_blank">https://gtchaxonline.com/</a>
              上由公司策划、开发和运营的付费服务的协议。</span>
            <span class="text">8 所有使用付费服务的用户均应遵守本协议的条款和条件。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第五条（服务利用者解除服务使用合同）</span>
            <span class="text">服务使用者可以随时按照本服务上的取消程序或本公司另行规定的其他取消程序取消服务使用合同。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第六条（注册使用本服务）</span>
            <span class="text">1 服务使用者必须自费并负责准备服务使用者使用本服务所需的终端、通讯设备、软件、连接互联网的合同等。</span>
            <span class="text">2 本公司对服务使用者使用本服务的环境不存在任何参与，也不承担任何责任。</span>
            <span class="text">3 服务用户可以在注册时注册自己的电子邮件地址，并将其用作服务的电子邮件地址。请注意，您无法在网站上更改您的电子邮件地址，因此，如果您注册时使用了错误的电子邮件地址或更改了您的电子邮件地址，我们将在进行更改之前确认您的身份。</span>
            <span class="text">4 服务使用者一般限于每人一个账户，禁止拥有多个账户。此外，如果本公司发现服务使用者拥有多个帐户，本公司将删除该服务使用者拥有的帐户，恕不另行通知。此时，充入已删除帐户的所有硬币都将被没收。</span>
            <span class="text">5 如果公司认为本网站的运营有困难，公司可以限制服务用户使用本服务，直至原因得到解决。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第七条（账户管理）</span>
            <span class="text">1 用户负责注册和管理其注册使用的信息（以下简称“注册信息”，包括电子邮件地址、ID、密码等）。用户不得允许任何第三方使用，亦不得出借、转让、更名、买卖等。</span>
            <span class="text">2 如果根据注册信息使用本服务，公司可将其视为注册使用人使用，该使用后果及相关责任由注册使用人承担。</span>
            <span class="text">3. 如果用户因未经授权使用注册信息而给公司或第三方造成损害的，用户应赔偿公司和第三方的损失。</span>
            <span class="text">4、用户管理注册信息的风险由用户自行承担，本公司对因注册信息错误或虚假而给用户造成的任何不利或损害不承担任何责任。</span>
            <span class="text">5、如发现注册信息被盗用或被第三方使用，用户应立即通知本公司，并按照本公司的指示进行处理。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第八条（服务使用者的义务）</span>
            <span class="text">1 除非公司明确许可，服务使用者不得就本服务进行下列任何行为。</span>
            <span class="text">（一）违反法律、法规的行为</span>
            <span class="text">(2) 违反本使用条款的行为</span>
            <span class="text">(3) 给公司或第三方造成不公平的不利或损害的行为</span>
            <span class="text">(4) 将本服务的各项功能用于其他目的</span>
            <span class="text">(5) 以与正常使用本服务时不同的方式使用本服务（包括自动化和抓取）</span>
            <span class="text">(6) 侵犯本公司或第三方的知识产权</span>
            <span class="text">(7) 侵犯本公司或第三方的隐私权或肖像权</span>
            <span class="text">(8) 泄露本公司或第三方机密信息</span>
            <span class="text">(9) 向第三方提供可在服务内查看的信息</span>
            <span class="text">(10) 未经本人同意向第三方提供个人信息</span>
            <span class="text">(11) 对本公司或第三方的诽谤</span>
            <span class="text">(12) 损害本公司或第三方的名誉或信誉</span>
            <span class="text">(13) 冒充本公司或第三方</span>
            <span class="text">(14) 第三方账户信息的使用</span>
            <span class="text">(15) 篡改或删除用于提供服务的系统中记录的信息；</span>
            <span class="text">(16) 发送有害的计算机程序等，或者根据本公司或第三方的要求提供传播。</span>
            <span class="text">(17) 其他服务和产品、团体和组织等的广告、促销或招揽。</span>
            <span class="text">(18) 干扰本服务的提供及其他运营</span>
            <span class="text">(19) 传输含有计算机病毒或其他有害计算机程序的信息</span>
            <span class="text">(20) 对用于提供服务的电信设备（包括但不限于服务器；以下简称“电信设备”）造成过度负载的行为。</span>
            <span class="text">(21) 取消或规避用于提供服务的系统中设置的访问控制功能等未经授权的访问。</span>
            <span class="text">(22) 对本服务中使用的软件进行复制、修改、转载、修改、更改、逆向工程、反汇编、反编译、翻译或分析。</span>
            <span class="text">(23) 通过欺诈手段（包括所谓的网络钓鱼和类似手段）从公司或第三方获取信息</span>
            <span class="text">(24) 给我们打电话的时间过长，重复进行类似的询问，或者在没有义务和理由的情况下强迫我们答复。</span>
            <span class="text">(25) 通过销售设备、提供信息、设置超链接等方式鼓励上述行为的行为。</span>
            <span class="text">(26) 可能属于上述各项的行为。</span>
            <span class="text">(27) 其他本公司认为不当的行为（不适当的注册名称、重复账户、查询时的评论内容等）</span>
            <span class="text">2 如果账户信息发生变更，服务使用者必须及时登记变更后的信息。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第9条（个人信息的处理）</span>
            <span class="text">服务使用者同意本公司将按照我们的个人信息保护政策的规定处理其个人信息。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十条（服务使用者相关信息的删除）</span>
            <span class="text">1 如果与服务使用者解除服务合同，公司将删除该服务使用者的相关信息（包括但不限于账户信息、应用内货币、付费服务相关信息）。</span>
            <span class="text">2 本公司不会恢复根据前款规定删除的服务利用者的信息。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十一条（服务相关权利）</span>
            <span class="text">与本公司通过本服务向服务用户提供的内容和信息有关的知识产权和其他权利属于本公司或已授予本公司权利的第三方。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十二条（关于有偿服务）</span>
            <span class="text">1 服务使用者可以按照本公司规定的方法，按照本公司在本服务或本公司提供的其他服务中提示的金额，购买只能在本公司提供的服务范围内使用的硬币。此外，公司可以为服务使用者设定购买金币的购买单位、支付方式、使用期限及其他购买条件，所设定的购买条件和应付金额等将在服务内公布。</span>
            <span class="text">2 Coin 使用条款以及与使用 Coin 相关的其他条件除本使用条款外，还应遵守本网站上发布的 Coin 使用条款。</span>
            <span class="text">3. 服务使用者应按照本公司另行确定的支付方式和条件支付有偿服务使用费（包括服务使用者因有偿服务而产生的任何其他债务）。任何费用一经支付，本公司将不予退还，除非本公司负有法律责任，例如由于本公司的疏忽。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十三条（关于产品）</span>
            <span class="text">1 服务使用者可以接收通过付费服务获得的产品的交付。</span>
            <span class="text">2. 服务使用者自购买之日起最多可持有所购买的商品24小时（以下简称“持有期间”），如需交付，必须在本网站办理规定的交付手续。</span>
            <span class="text">3 如果超过前款规定的保留期限，服务使用者将失去接收该产品的权利。请注意，超过持有期限的产品将自动返回到Coin。</span>
            <span class="text">4. 如果由于公司的原因导致公司无法交付服务利用者获取的产品，公司将向服务利用者释放服务利用者用于获取产品的代币，从而免除公司的损害责任。请注意，我公司没有义务采购和交付与上述产品相同的产品。</span>
            <span class="text">5 与产品相关的运费将由我们全额承担。请注意，海外运送可能会收取额外费用。</span>
            <span class="text">6 我们将使用我们的合作伙伴大和运输有限公司或我们指定的承运商进行送货。</span>
            <span class="text">7 每月5日、10日、15日、20日、25日、最后一天发货至我司指定的运输公司。</span>
            <span class="text">*如果您在上述送货时间之前或之后使用该服务，则送货时间可能是下一个或更晚的送货时间，而不是最近的送货时间。</span>
            <span class="text">*发货准备完成后，我们会立即通知您。因此，追踪号码可能要到第二天才会反映在互联网上。感谢您的理解。</span>
            <span class="text">8、对于产品运输过程中出现的损坏等问题，我们不承担任何责任。</span>
            <span class="text">9 如果在交付产品之前发现服务使用者违反了使用条款，公司可以暂停交付产品。由此造成的损失，本公司不承担赔偿责任，敬请谅解。</span>
            <span class="text">10 我公司将产品交付给服务使用者后，如果因地址不明等原因导致产品被拒收或退回，且服务使用者未遵循重新发送程序，则服务使用者将失去对该产品的所有权利。即使在这种情况下，公司也没有义务提供任何补偿或损害赔偿，例如返还硬币的义务。</span>
            <span class="text">11. 对于无法回复有关交货日期等的询问，我们深表歉意。</span>
            <span class="text">12.本系统中，产品名称和奖励币是关联的。 万一图片与产品名称不符，我们将优先考虑产品名称和奖励币，而不是图片中的产品或奖励币。感谢您的理解。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第14条（信用卡等的使用）</span>
            <span class="text">1 在本网站上，服务使用者可以通过信用卡支付或使用本公司提供的其他服务中指定的方法购买金币。但是，用于付款的信用卡必须是服务使用者的姓名，并且在付款时必须有效。</span>
            <span class="text">2 使用信用卡支付时，服务利用者应按照本公司规定的方法，以服务利用者的名义登记信用卡信息（信用卡种类、卡号、有效期限等，以下统称为“信用卡信息”）。</span>
            <span class="text">3、对于因信用卡信息登记错误等给服务使用者造成的任何损失，本公司不承担任何责任。此外，如果服务使用者因信用卡使用方面的虚假或欺诈而使公司遭受损失，则服务使用者应对公司遭受的任何及全部损失进行赔偿。</span>
            <span class="text">4 当使用信用卡支付使用本网站所产生的费用时，公司应按规定方式向服务利用者用于支付的信用卡请求信用卡公司的批准，如果未获得批准，则不得进行支付。在此情况下，即使服务利用者遭受损害，本公司也不承担任何责任。</span>
            <span class="text">5 即使在服务利用者的信用卡付款完成后，如果信用卡公司通知本公司拒绝或暂停使用信用卡，或者如果发现服务利用者在信用卡的使用方面存在撒谎或欺诈行为，则无论何种原因，公司都可以取消服务利用者的所有付款。</span>
            <span class="text">6 服务使用者可以在公司提供的其他服务中购买可用于本服务的金币，但在这种情况下，他们必须使用与本服务相同的帐户进行购买，如果使用其他帐户购买金币，则他们承认该金币不会反映在本服务中且无法使用。在此情况下，我公司将不提供任何退款或承担任何责任。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十五条（与支付机构等的关系）</span>
            <span class="text">1 如果服务使用者与本公司在本服务中使用的结算公司或支付机构之间就本服务的收费或其他财务义务发生争议，则该争议应由服务使用者与本公司解决，本公司不参与该等争议且不承担任何责任。</span>
            <span class="text">2 因服务利用者的原因发生前款纠纷，致使本公司遭受损失时，服务利用者应赔偿公司遭受的全部损失。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第16条（本服务的停止等）</span>
            <span class="text">有下列情形之一的，本公司可以暂时停止提供全部或部分服务，且不承担损害赔偿或其他义务。</span>
            <span class="text">(1) 对提供本服务的设备进行维护或检查时。</span>
            <span class="text">(2) 因火灾、停电等原因导致本服务的提供中断时。</span>
            <span class="text">(3) 由于地震、火山喷发、洪水、海啸等自然灾害而导致本服务的提供中断的情况。</span>
            <span class="text">(4) 因战争、动乱、骚乱、骚乱、劳资纠纷、传染病蔓延、紧急事态宣言等原因导致本服务的提供中断时。</span>
            <span class="text">(5) 由于本服务的运营或技术原因，公司认为有必要暂时推迟或停止提供本服务时。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十七条（使用限制等）</span>
            <span class="text">1 如果本公司认定服务使用者属于下列情形之一，本公司可以在不事先通知服务使用者的情况下，采取暂停使用本服务或解除服务使用协议等措施（以下简称“使用限制措施”）。</span>
            <span class="text">(1) 因服务使用者密码泄露而导致第三方非法使用本服务，或第三方非法使用我们的其他服务，或存在此类风险的。</span>
            <span class="text">(2) 如果确定服务使用者的行为将妨碍我们的业务。</span>
            <span class="text">(3) 如果您拥有多个帐户（禁止行为）。</span>
            <span class="text">(4) 违反使用条款或存在违反使用条款的风险时。</span>
            <span class="text">(5) 除前项外，公司认为有必要采取限制使用措施的情况。</span>
            <span class="text">2 即使因公司根据第一项采取限制使用措施而对服务利用者造成损害，公司也不对该损害承担责任。</span>
            <span class="text">3 如果根据本条解除服务使用合同，服务使用者将失去对公司所欠债务期限的利益，并且必须立即履行对公司的所有债务。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十八条（免责声明）</span>
            <span class="text">1 除本条款另有规定外，本公司不会对给服务用户造成的损失进行赔偿，且服务用户不得就该等损失向本公司提出索赔。此外，如果服务使用者因使用或终止使用本服务而对第三方造成损害，则使用者应自行承担解决该损害的风险，本公司不承担任何责任。但因本公司故意或重大过失造成损害时，则不在此限。</span>
            <span class="text">2 对于因自然灾害、战争、骚乱、内乱、火灾蔓延引起的火灾、水灾、法律法规的修改或废止、停电、政府机关的干预、罢工或其他劳资纠纷、交通事故、传染病蔓延、紧急状态宣言的发布或其他不可归咎于公司的原因而导致的损害或未履行服务使用合同项下的义务的任何其他责任，公司不承担责任。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十九条（服务使用者的通知）</span>
            <span class="text">服务使用者同意公司可以通过以下方式之一通知服务使用者。</span>
            <span class="text">(1) 这将在服务中发布。在这种情况下，对服务用户的通知将被视为在发布时已完成。</span>
            <span class="text">(2) 我们会将其发布在我们的网站上。在这种情况下，对服务用户的通知将被视为在发布时已完成。</span>
            <span class="text">(3) 向服务利用者在申请使用时及其后通知本公司的电子邮箱地址发送电子邮件。在这种情况下，当电子邮件被发送到服务利用者的电子邮件地址时，将被视为已经完成对服务利用者的通知。</span>
            <span class="text">(4) 此外，我们还将以我们认为适当的任何其他方式这样做。在这种情况下，对服务利用者的通知将被视为已在公司在通知中指定的时间完成。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第二十条（排除反社会势力）</span>
            <span class="text">服务用户声明并保证以下内容：</span>
            <span class="text">（一）申请人过去或将来不得是反社会势力（包括有组织犯罪集团、有组织犯罪成员、有组织犯罪集团关联成员、有组织犯罪相关企业、企业敲诈勒索者、社会运动暴徒、政治活动暴徒、特殊情报团伙等，下同），未曾与反社会势力有过任何业务往来，未曾通过提供资金等行为配合或参与反社会势力的维持、运作，无其他故意行为与反社会势力互动。</span>
            <span class="text">（二）不得对公司及其员工进行殴打、伤害、恐吓、勒索、胁迫等暴力、威胁行为；不得以散布谣言、诬告等欺诈方式提出超出合理限度的无理要求；不得损害公司及其员工的声誉或信任；</span>
            <span class="text">(3) 不得做出告知本公司或第三方您是反社会势力或与反社会势力有关系等行为。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第21条（服务使用合同等的状态转移）</span>
            <span class="text">1 服务使用者不得将服务使用合同项下的地位或与服务使用合同相关的权利或义务转让、继承、买卖、变更名称、设定抵押物等给第三方。</span>
            <span class="text">2 无论以何种方式进行业务转让、公司分立、合并等，如果公司将与本服务相关的业务转让或继承给第三方（以下简称“业务转让等”），公司可以在未征得服务利用者同意的情况下，将服务使用协议项下的地位、基于服务使用协议的权利和义务以及账户信息处理权限转让或继承给受让人。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第二十二条（义务的存续）</span>
            <span class="text">即使服务使用协议终止，服务使用者仍不免除服务使用协议终止前所产生的任何义务。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第23条（条款的变更）</span>
            <span class="text">1 在下列情况下，公司可以在未事先征得服务使用者同意的情况下变更本条款。在这种情况下，公司将提前将修改后的使用条款通知服务用户。</span>
            <span class="text">(1) 本使用条款的变更符合服务用户的普遍利益。</span>
            <span class="text">(2) 本使用条款的变更不与服务使用协议的目的相抵触，且考虑变更的必要性、变更内容的适当性以及与变更相关的其他情况是合理的。</span>
            <span class="text">2 除前款规定外，公司可以在征得服务使用者的同意后更改本使用条款。</span>
            <span class="text">3 出现下列情形之一的，服务使用者将被视为同意本使用条款的变更。</span>
            <span class="text">(1) 如果公司在变更前至少一个月向服务使用者通知本使用条款的拟议变更及变更日期，并且服务使用者在使用条款变更之日之前未以书面形式向本公司表示反对本使用条款的变更。</span>
            <span class="text">(2) 如果公司将使用条款的拟议变更以及使用条款的变更日期通知服务使用者，并且服务使用者在变更日期之后使用服务；</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第二十四条（管辖）</span>
            <span class="text">对于服务利用者与本公司之间有关本条款或服务使用协议的任何诉讼，东京地方法院拥有一审专属管辖权。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">成立于2025年2月28日</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },
  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.terms-of-service{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: black;
  .terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .shadow-box {
        justify-content: left;
      }
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          color: black;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .terms-of-service {
    .scroll-container {
      .shadow-box-title-description {
        .text-container {
          span.text {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
